import api from './api';
import { saveToken } from '../utils/storage';

export const registerUser = (userData) =>
  api.post('/api/auth/register', userData)
    .then(r => r.data)
    .catch(error => {
      console.error('Register user error:', error);
      throw error;
    });

export const activateUser = (userData) =>
  api.post('/api/auth/activate', userData)
    .then(r => r.data)
    .catch(error => {
      console.error('Activate user error:', error);
      throw error;
    });

export const resendUserActivation = (userData) =>
  api.post('/api/auth/resendactivation', userData)
    .then(r => r.data)
    .catch(error => {
      console.error('Resend user activation error:', error);
      throw error;
    });

export const signInUser = (credentials) =>
  api.post('/api/signin', credentials)
    .then(r => {
      if (r.data.token) {
        saveToken(r.data.token);
      }
      return r.data;
    })
    .catch(error => {
      console.error('Sign in user error:', error);
      throw error;
    });

export const resumeUser = (userData) =>
  api.post('/api/auth/resume', userData)
    .then(r => {
      if (r.data.token) {
        saveToken(r.data.token);
      }
      return r.data;
    })
    .catch(error => {
      console.error('Resume user error:', error);
      throw error;
    });

export const logout = () => {
  localStorage.removeItem('userDetailsAdmin');
  localStorage.removeItem('authToken');
};

export const verifyToken = () =>
  api.post('/api/auth/verify')
    .then(r => r.data)
    .catch(error => {
      console.error('Token verification error:', error);
      throw error;
    });

export const refreshToken = (token) =>
  api.post('/api/auth/refresh', { token })
    .then(r => {
      if (r.data.token) {
        saveToken(r.data.token);
      }
      return r.data;
    })
    .catch(error => {
      console.error('Token refresh error:', error);
      throw error;
    });

export const logOutUser = (userData) =>
  api.post('/api/logout', userData)
    .then(r => r.data)
    .catch(error => {
      console.error('Logout user error:', error);
      throw error;
    });

export const updateUser = (userData) =>
  api.post('/api/update', userData)
    .then(r => r.data)
    .catch(error => {
      console.error('Update user error:', error);
      throw error;
    });

export const forgotUser = (userData) =>
  api.post('/api/forgot', userData)
    .then(r => r.data)
    .catch(error => {
      console.error('Forgot user error:', error);
      throw error;
    });

export const resetUser = (userData) =>
  api.post('/api/reset', userData)
    .then(r => r.data)
    .catch(error => {
      console.error('Reset user error:', error);
      throw error;
    });

export const userApplyForMav = (userData) =>
  api.post('/api/applyformav', userData)
    .then(r => r.data)
    .catch(error => {
      console.error('User apply for mav error:', error);
      throw error;
    });
